import { Box, Grid2, Typography } from '@mui/material';

import FeedbackCard from 'src/components/feedback/feedbackCard';
import React from 'react';
import StarEyesGif from 'src/resources/gifs/STAR_GIF.gif';
import { content } from 'src/common/lang/en-US';

const FeedBackPage: React.FC = () => {
    const heading = content?.feedback?.pageHeading ?? '';
    const words = heading.split(' ');
    const lastWord = words.pop() ?? '';
    const firstPart = words.join(' ');

    return (
        <Box
            paddingX={{ lg: '10rem', md: '5rem', sm: '3rem', xs: '2rem' }}
            paddingY={{ md: '4rem', xs: '3rem', xxl: '7rem' }}
            style={{ backgroundColor: 'white', height: '100%', width: '100%' }}
        >
            <Grid2 columns={7} container spacing={2}>
                <Grid2 size={{ lg: 3, md: 3, sm: 7 }}>
                    <Typography color="primary.contrastText" variant="h1_Thin">
                        {/* Render the first part of the heading */}
                        {firstPart} {/* Render the last word and the GIF inline */}
                        <Box
                            component="span"
                            sx={{
                                display: 'inline-block',
                                marginTop: '-3rem',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {lastWord}{' '}
                            <Box
                                alt="review gif"
                                component="img"
                                src={StarEyesGif}
                                sx={{
                                    display: 'inline-block',
                                    height: { xs: 100, xxl: 200 },
                                    marginLeft: { xs: '-3.5rem', xxl: '-7rem' },
                                    marginTop: '2rem',
                                    transform: 'rotate(150deg)',
                                    transformOrigin: 'center center',
                                    verticalAlign: 'middle',
                                    width: { xs: 170, xxl: 'auto' },
                                }}
                            />
                        </Box>
                    </Typography>
                </Grid2>
                <Grid2 gap="20px" size={{ lg: 4, md: 4, sm: 7 }}>
                    <FeedbackCard />
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default FeedBackPage;
